export const MESSAGES_ERREURS = {
  'error.validation': 'Formulaire invalide. Vérifiez que tous les champs sont correctement remplis',
  'error.http.500': 'Une erreur s\'est produite. \nVeuillez contacter votre administrateur.'
};
